// Unpublished Work © 2020 Deere & Company

import t from 'tcomb';

export const searchConstraints = {
    CONTAINS: 'CONTAINS',
    STARTS_WITH: 'STARTS_WITH'
};

export const SearchConstraints = t.enums(searchConstraints, 'SearchConstraints');
